var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { cloneDeep } from "lodash-es";
import Draggable from 'vuedraggable';
import { INJECT_SIMPLE_FLOW_EDITOR, INJECT_SIMPLE_FLOW_STEP_EDITOR, INJECT_SIMPLE_FLOW_STEP_LIST } from './consts';
import FlowAtomSelector from "./FlowAtomSelector";
import SimpleFlowStepEditor from './SimpleFlowStepEditor';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import classNames from "../../../lib/utils/classNames";
import { Inject } from 'vue-property-decorator';
import { removeItems } from '@lyonbot/interactive-blocks';
import { delay } from "../../../lib/utils";
import { CTRL_KEY } from "../../../lib/utils/consts";
const GetRandomKey = () => Date.now().toString(36);
let SimpleFlowStepList = class SimpleFlowStepList extends Vue {
  constructor() {
    super(...arguments);
    this.isDragging = false;
  }
  getNewStepOfAtom(atomId) {
    const atom = this.flowEditor.atoms[atomId];
    // eslint-disable-next-line no-underscore-dangle,@typescript-eslint/naming-convention
    const _key = GetRandomKey();
    const step = {
      type: atomId,
      params: cloneDeep((atom === null || atom === void 0 ? void 0 : atom.defaultParams) || {}),
      _key
    };
    return step;
  }
  addStep(atomId) {
    this.steps.push(this.getNewStepOfAtom(atomId));
    this.$nextTick(() => {
      this.$refs.stepEditors.forEach(obj => obj && (obj.showParams = false));
      const stepEditor = this.$refs.stepEditors[this.steps.length - 1];
      if (stepEditor) {
        stepEditor.showParams = true;
        stepEditor.ibBlock.select();
        stepEditor.ibBlock.focus();
      }
    });
  }
  changeStepType(index, atomId) {
    this.$set(this.steps, index, this.getNewStepOfAtom(atomId));
    this.$nextTick(() => {
      const stepEditor = this.$refs.stepEditors[index];
      if (stepEditor) stepEditor.showParams = true;
    });
  }
  removeStep(index) {
    const indexes = !Array.isArray(index) ? [index] : [...index].sort((a, b) => b - a);
    indexes.forEach(i => this.steps.splice(i, 1));
    if (!indexes.length) return;
    // const lastIndex = indexes[indexes.length - 1]!;
    // // drawerVisible 要从组件实例继承一下 比如删掉第四个 那要让第五个的菜单保持打开才行
    // this.$nextTick(() => {
    //   const stepEditor = this.$refs.stepEditors[lastIndex];
    //   if (stepEditor) stepEditor.drawerVisible = true;
    // });
    this.flowEditor.flushChanges();
  }
  copyStep(index) {
    if (!this.steps[index]) return false;
    const newStep = cloneStep(this.steps[index]);
    this.steps.splice(index + 1, 0, newStep);
    this.flowEditor.flushChanges();
  }
  handleDragStart(ev) {
    const {
      oldDraggableIndex: oldIndex
    } = ev;
    const {
      ibSlot
    } = this;
    let draggingIndexes = Array.from(ibSlot.isActive ? ibSlot.items : []).filter(x => x.isActive).map(x => x.index);
    // 拖拽当前选中的一个块
    if (!draggingIndexes.includes(oldIndex)) {
      draggingIndexes = [oldIndex];
    }
    this.isDragging = draggingIndexes;
  }
  handleDragEnd(ev) {
    const {
      oldDraggableIndex: oldIndex,
      newDraggableIndex: newIndex,
      from: fromDom,
      to: toDom,
      originalEvent
    } = ev;
    const draggingIndexes = this.isDragging;
    this.isDragging = false;
    if (oldIndex === newIndex && fromDom === toDom || !draggingIndexes) {
      this.ibSlot.focus();
      return;
    }
    // eslint-disable-next-line no-underscore-dangle
    const to = toDom.__vue__.$parent;
    const isCopying = originalEvent[CTRL_KEY];
    let toInsertItems = removeItems(isCopying ? this.steps.slice() : this.steps, draggingIndexes);
    if (isCopying) toInsertItems = toInsertItems.map(cloneStep);
    const baseI = Math.min(to.steps.length, newIndex);
    to.steps.splice(baseI, 0, ...toInsertItems);
    this.flowEditor.flushChanges();
    to.ibSetActiveBlocks(toInsertItems.map((_, i) => i + baseI));
  }
  async ibSetActiveBlocks(indexes, noFocus) {
    await this.$nextTick();
    await delay(150);
    const {
      ctx,
      items
    } = this.ibSlot;
    ctx.activeBlocks.clear();
    // eslint-disable-next-line no-restricted-syntax
    for (const block of items) {
      if (indexes.includes(block.index)) ctx.activeBlocks.add(block);
    }
    ctx.activeSlot = this.ibSlot;
    ctx.syncActiveElementStatus();
    if (!noFocus) ctx.focus();
  }
  created() {
    var _this$flowStepEditor;
    const ibParent = ((_this$flowStepEditor = this.flowStepEditor) === null || _this$flowStepEditor === void 0 ? void 0 : _this$flowStepEditor.ibBlock) || this.flowEditor.ibContext; // use `blockContext` if no ownerBlock
    this.ibSlot = ibParent.createSlot({
      ref: this,
      onCut: action => {
        const indexes = action.blocks.map(block => block.index);
        removeItems(this.steps, indexes);
        this.flowEditor.flushChanges();
      },
      onPaste: action => {
        const rawBlocksData = action.data.blocksData; // object array from clipboard
        const blocks = rawBlocksData.map(item => cloneStep(item)).filter(Boolean);
        this.steps.splice(action.index, 0, ...blocks); // insert into the array
        this.flowEditor.flushChanges();
      }
    });
  }
  beforeDestroy() {
    this.ibSlot.dispose();
  }
  handlePointerUp(ev) {
    this.ibSlot.handlePointerUp();
    if (document.activeElement === ev.currentTarget) this.ibSlot.ctx.focus();
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-sfeList-wrapper",
      "on": {
        "pointerup": this.handlePointerUp
      },
      "attrs": {
        "tabIndex": "-1"
      }
    }, [h("draggable", {
      "attrs": {
        "value": this.steps,
        "handle": ".ucd-sfeStep-handle, .ucd-sfeStep-toggle, .ucd-sfeStep-title-handle, .ucd-sfeStep-actions-content",
        "draggable": ".ucd-sfeStep",
        "animation": 300,
        "group": "ucd-sfe"
      },
      "class": classNames('ucd-sfeList', this.isDragging && 'isDragging'),
      "on": {
        "start": this.handleDragStart,
        "end": this.handleDragEnd
      }
    }, [this.steps.map((step, index) => h("simple-flow-step-editor", {
      "attrs": {
        "index": index
      },
      "ref": "stepEditors",
      "refInFor": true,
      "key": `${index}_${step._key}` || `${index}_${step.type}`
    })), !!this.steps.length ? h("div", {
      "slot": "header"
    }, [h("div", {
      "class": "ucd-sfeList-decoratorLine"
    })]) : null, h("div", {
      "slot": "footer",
      "class": ['ucd-sfeList-footer', !!this.steps.length && 'footerTab']
    }, [h("div", {
      "class": "ucd-sfeToggle isGreen ucd-sfeList-footer-plusIcon",
      "on": {
        "click": this.focusAddStepInput
      }
    }, ["\uFF0B"]), h("div", {
      "class": mergeClassName('ucd-sfeList-footer-textBox', !!this.steps.length && 'isInFilledList')
    }, [h("flow-atom-selector", {
      "attrs": {
        "placeholder": "添加行为步骤"
      },
      "on": {
        "change": this.addStep
      },
      "ref": "addStepInputbox"
    }), !this.steps.length && h("div", {
      "class": "ucd-sfeList-footer-noticeAdd"
    })])])])]);
  }
  focusAddStepInput() {
    const input = this.$refs.addStepInputbox.$el;
    input.focus();
    input.click();
  }
};
__decorate([Inject({
  from: INJECT_SIMPLE_FLOW_EDITOR
})], SimpleFlowStepList.prototype, "flowEditor", void 0);
__decorate([Inject({
  from: INJECT_SIMPLE_FLOW_STEP_EDITOR,
  default: null
})], SimpleFlowStepList.prototype, "flowStepEditor", void 0);
SimpleFlowStepList = __decorate([Component({
  name: 'SimpleFlowStepList',
  props: {
    steps: {
      required: true
    } // 注意，这个组件会直接读写!!!!!!!
  },
  components: {
    Draggable,
    SimpleFlowStepEditor,
    FlowAtomSelector
  },
  provide() {
    return {
      [INJECT_SIMPLE_FLOW_STEP_LIST]: this
    };
  }
})], SimpleFlowStepList);
export default SimpleFlowStepList;
const cloneStep = value => {
  if (!value || !value.type) return null;
  const step = cloneDeep(value);
  const dfsChangeKey = obj => {
    if (obj && typeof obj === 'object') {
      // eslint-disable-next-line no-underscore-dangle
      if (obj._key) obj._key = GetRandomKey();
      Object.values(obj || {}).forEach(dfsChangeKey);
    }
  };
  dfsChangeKey(step);
  // 递归跑一遍_key全都更换
  return step;
};
//# sourceMappingURL=SimpleFlowStepList.js.map
